#import "../../../../common/graphql/EntityDocumentsFields.graphql"
query BatchTransaction($id: UUID!) {
  batchTransaction(id: $id) {
    id
    __typename
    _urgencyLevel
    _rowTimestamp
    referenceNumber
    weekNumber
    description
    postingDate
    currencyId
    currency {
      isoCode
    }
    _isApprovalDocumentsRequired
    _requiredApprovalDocuments
    statusType {
      statusType
        _transactionIconStatus

    }
    _createdByUserName
    _createdByUserid
    companyCorporatePeriod {
      _periodYear
      startDate
      endDate
    }
    controlTotalAmount
    corporatePeriodId
    _batchTransactionCount
    _batchTransactionTotal
    _isUpdatable
    _isDeletable
    _isVerifiable
    _isStagedApprovalRequest
    _isApprovalRevocable
    invoiceBatches(orderBy: [_SORT_ACCOUNTING_REFERENCE_ASC, PRIMARY_KEY_ASC]) {
      nodes {
        id
        _rowTimestamp
        batchTransactionId
        invoiceId
        comment
        _isDeletable
        invoiceBatchTransactionType {
          transactionType
        }
        invoice {
          vendorReference
          invoiceNumber
          description
          invoiceDate
          _accountingStampTransactionReference
          _isAccountingEntryStampedComplete
        }
        appliedAmount
      }
      aggregates {
        sum {
          appliedAmount
        }
      }
    }
    batchTransactionHistoriesByEntityId {
      nodes {
        crudOperation
        pointInTimeDate
      }
    }
    approvalHistorySignaturesByEntityId(
      orderBy: SORT_ORDER_ASC
      filter: {
        not: {
          isApproved: { equalTo: false }
          isRejected: { equalTo: false }
          isRequested: { equalTo: false }
        }
      }
    ) {
      nodes {
        id
        additionalInformation
        digitalSignature
        actionDate
        isApproved
        isRejected
        isRequested
        userName
        entityDocumentId
        userOccupationTitle
        userSignatureDocument {
          id
          _downloadLink
          fileIndexInformation
          fileReference
          iconType
          __typename
        }
        __typename
      }
      __typename
    }
    approvalHistoriesByEntityId(orderBy: REQUESTED_DATE_DESC) {
      nodes {
        id
        requesterName
        requestedDate
        amount1
        currencyIsoCode
        isApprovalTreeViewerAllowed
        iconType {
          iconType
          iconState
        }
        statusType {
          statusType
        }
      }
    }
    notesByEntityId(orderBy: _CREATED_DATE_DESC) {
      nodes {
        id
        _createdByUserName
        _createdDate
        noteComment
        isShared
        _isUpdatable
        _rowTimestamp
      }
    }
    userMessagesByEntityId {
      totalCount
      nodes {
        id
        messageComment
      }
    }
    userNotificationsByEntityId {
      nodes {
        id
        messageComment
      }
    }
    isDraft
    entityDocumentsByEntityId(
      orderBy: [DOCUMENT_POSITION_ASC, _CREATED_DATE_DESC, FILE_REFERENCE_ASC]
    ) {
      nodes {
        ...EntityDocumentsFields
      }
      totalCount
    }
    batchTransactionHistoriesByEntityId {
      nodes {
        tenantUserName
        pointInTimeDate
        crudOperation
      }
    }
  }
}
